exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-detail-center .ivu-modal-body{max-height:calc(100vh - 300px);overflow:auto}", ""]);

// exports
